import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    signedIn: false,
    signedUp: false,
    currentUser: false,
    alert: {
      info: "",
      warning: "",
      danger: "",
      success: ""
    }
  },
  mutations: {
    setSignedIn(state, isSignedIn) {
      state.signedIn = isSignedIn;
    },
    setSignedUp(state, hasSignedUp) {
      state.signedUp = hasSignedUp;
    },
    setCurrentUser(state, currentUser) {
      state.currentUser = currentUser;
    },
    setAlert(state, alertData) {
      if (!{}.hasOwnProperty.call(state.alert, alertData.variant)) {
        console.log("setAlert: invalid variant");
      } else {
        state.alert[alertData.variant] = alertData.message;
      }
    },
    unsetAlert(state, variant) {
      if (!{}.hasOwnProperty.call(state.alert, variant)) {
        console.log("unsetAlert: invalid variant");
      } else {
        state.alert.variant = "";
      }
    },
    unsetAllAlerts(state) {
      const variants = Object.keys(state.alert);
      for (let variant in variants) {
        state.alert[variants[variant]] = "";
      }
    }
  },
  actions: {},
  modules: {}
});
